import React from 'react';
import Footer from "../components/footer";
import { NavbarComponent } from '../components/navbar';
import styles from '../styles/request.module.css';
import uca from '../assets/images/uca/ultimateCannabis.png';
import longText from '../assets/images/uca/longText.png';
import cannaLogo from '../assets/images/uca/cannalogo.png';
import business1 from '../assets/images/uca/hfl.png';
import business2 from '../assets/images/uca/euphoria.png';
import business3 from '../assets/images/uca/dadirri.png';
import business4 from '../assets/images/uca/naturesChemistry.png';
import business5 from '../assets/images/uca/pannaLogo.png'
import business6 from '../assets/images/uca/summa.png';
import business7 from '../assets/images/uca/demarcos.png';
import business8 from '../assets/images/uca/logoNew.png';
import bg from '../assets/images/uca/spacebg.jpg';

import apple from '../assets/images/applenew.png';
import google from '../assets/images/googledwnld.png'
import { Helmet } from 'react-helmet';

export const UltimateCannabisAdventurePage = () => {
    return (
        <div className="page-margin" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', marginTop: 30 }}>
            <Helmet>
                <title>CANNA42 | Ultimate Cannabis Adventure</title>
                <meta name="description" content="Come celebrate our launch with us! The Ultimate Cannabis Adventure is an IRL and virtual scavenger hunt running 7/1 - 8/12, that you participate in exclusively through CANNA42. Earn points and win prizes by solving clues and completing challenges. " />
                <meta name="keywords" content="canna42, ultimate cannabis adventure, las vegas, cannabis, dispensaries, dispensary, las vegas ultimate cannabis adventure, canna42 ultimate cannabis adventure" />
                {/* canolical */}
                <link rel="canonical" href="https://canna42.com/ultimate-cannabis-adventure" />
            </Helmet>
            <NavbarComponent />
            <section className="auth-page request-page py-5 custom-style-page">
                <div className="container text-center d-flex flex-column align-items-center">
                    <img src={cannaLogo} alt="Canna Logo" className={`img-fluid mb-4 ${styles.cannaLogo}`} />
                    <img src={uca} alt="Ultimate Cannabis Adventure" className={`img-fluid mb-3 ${styles.ucaImage}`} />
                    <img src={longText} alt="Description" className={`img-fluid mb-4 ${styles.longText}`} />
                    <p className={`${styles.description} text-white fs-4 mb-4 lh-base mt-5`}>Come celebrate our launch with us! The Ultimate Cannabis Adventure is an IRL and virtual scavenger hunt running 7/1 - 8/12, that you participate in exclusively through CANNA42. Earn points and win prizes by solving clues and completing challenges. </p>
                    <div
                        className={`${styles.mobileDownload}`}
                        style={{

                        }}>
                        <a href="https://apps.apple.com/us/app/canna42/id6478886245" target="_blank" rel="noreferrer" style={{ display: 'inline-block' }}>
                            <img src={apple} alt="apple" className="img-fluid" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.canna42" target="_blank" rel="noreferrer" style={{ display: 'inline-block' }}>
                            <img src={google} alt="google" className="img-fluid" />
                        </a>
                    </div>
                    <h2 className="text-white fs-5 mb-4 mt-4">Featuring:</h2>
                    <div className="row justify-content-center gx-3 gy-3 align-items-center mt-2
                    ">
                        {[business1, business2, business3, business4, business5, business6, business7, business8].map((logo, index) => (
                            <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2 m-2">
                                <img src={logo} alt={`Business ${index + 1}`} className="img-fluid" style={{ maxHeight: '64px' }} />
                            </div>
                        ))}
                    </div>
                    <div style={{

                    }}
                        className={`${styles.desktopDownload}`}
                    >
                        <a href="https://apps.apple.com/us/app/canna42/id6478886245" target="_blank" rel="noreferrer" style={{ display: 'inline-block' }}>
                            <img src={apple} alt="apple" className="img-fluid" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.canna42" target="_blank" rel="noreferrer" style={{ display: 'inline-block' }}>
                            <img src={google} alt="google" className="img-fluid" />
                        </a>
                    </div>
                </div>
                {/* rules button */}
                <div className="position-absolute left-0 bottom-0" style={{
                    paddingLeft: 50,
                    paddingBottom: 30,
                }}>
                    <a href="/ultimate-cannabis-adventure/rules" className="text-white fs-5 mb-4 " style={{
                        textDecoration: 'underline'
                    }}>Rules</a>
                    {/* <button className="btn btn-primary">View Rules</button> */}
                </div>
            </section >
            <Footer />
        </div >
    );
};
